<template>
    <section class="chart-container">


        <el-row>
            <el-col :span="24" class="toolbar" style="padding:0" >
			<el-form  :inline="true"  style="float: right;padding-top:10px" @submit.native.prevent>
			<!-- @keyup.enter.native="getMember" -->
            <el-form-item v-if="value=='2'">
                <el-date-picker
                v-model="yearValue"
                type="year"
                 placeholder="选择年份">
             </el-date-picker>
            </el-form-item>
            <el-form-item v-if="value=='1'">
                <el-date-picker
                    v-model="monthValue"
                    type="month"
                    placeholder="选择月份">
                </el-date-picker>
            </el-form-item>
            <el-form-item v-if="value=='0'">
                <el-date-picker
                   v-model="weekValue"
                   type="week"
                   format="yyyy 第 WW 周"
                   placeholder="选择周">
               </el-date-picker>
            </el-form-item>
                
               <el-form-item >
                  <el-select v-model="value" placeholder  placeholder="请选择视图类型" style="width:192px">
                <el-option
                     v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                </el-option>
                 </el-select>
				</el-form-item>				
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="generate" icon="el-icon-search">生成统计</el-button>
				</el-form-item>			
			</el-form>
		</el-col>
                <el-col :span="24">
                <div id="chartLine" style="width:100%; height:400px;"></div>
            </el-col>
        </el-row> 
    </section>     
</template>

<script>

import {Statistics} from '../../../api/api';

  import echarts from 'echarts'

    export default {
        data() {
            return {
                chartLine: null, 
                legendData:[],     
                 xAxisData:[],
                 series:[],
                 options: [{
                     value: '0',
                    label: '周视图'
                    }, {
                      value: '1',
                     label: '月视图'
                    }, {
                     value: '2',
                     label: '年视图'
                    } ],
                    value: '1',
                    weekValue:'',
                    monthValue:'',
                    yearValue:''
             }
        },
        
        methods:{
             generate()
                      {
                   
                            this.StatisticsData();
                      },
              drawLineChart() {
                this.chartLine = echarts.init(document.getElementById('chartLine'));
                this.chartLine.setOption({
                    title: {
                        text: 'Line'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        // data: ['邮件营销', '联盟广告', '搜索引擎','邮件营销1', '联盟广告1', '搜索引擎1']
                        data:this.legendData
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data:this.xAxisData
                    },
                    yAxis: {
                         type: 'value',                       
                    },
                    series:this.series
                    // series: [
                    //     {
                    //         name: '次卡',
                    //         type: 'line',
                    //         stack: '总量',
                    //         data: [0, 132, 0, 134, 0, 230, 0]
                    //     },
                    //     {
                    //         name: '月卡',
                    //         type: 'line',
                    //         stack: '总量',
                    //         data: [182, 0, 191, 0, 290, 0, 310]
                    //     },
                    //     {
                    //         name: '年卡',
                    //         type: 'line',
                    //         stack: '总量',
                    //         data: [0, 932, 0, 934, 0, 1330, 0]
                    //     },
                    //      {
                    //         name: '充值卡',
                    //         type: 'line',
                    //         stack: '总量',
                    //         data: [132, 0, 101, 0, 90, 0, 210]
                    //     },
                    //     {
                    //         name: '培训卡',
                    //         type: 'line',
                    //         stack: '总量',
                    //         data: [0, 182, 0, 234, 0, 330, 0]
                    //     },
                        // {
                        //     name: '搜索引擎1',
                        //     type: 'line',
                        //     stack: '总量',
                        //     data: [820, 932, 901, 934, 1290, 1330, 1320]
                        // }
                    // ]
                });
            },
            drawCharts() {
               this.drawLineChart();
            },   
             StatisticsData(){
                 let queryTime='';
                 switch(this.value)
                 {
                     case '0':
                     {
                         queryTime=this.weekValue;
                         break;
                     }
                     case '1':
                     {
                         queryTime=this.monthValue;
                         break;
                     }
                     case '2':
                     {
                         queryTime=this.yearValue;
                         break;
                     }
                 }     
                 if(queryTime=='')
                 {
                    this.$message({
							message: "请先选择时间",
							type: 'error'
                        });                   
                    return;
                 }
                 let para={
                     ViewType:this.value,
                     StartDate:queryTime
                 };               
                    Statistics(para).then((res)=>{
                    //    console.log(res);

                        this.legendData=res.data.Data.LegendData;
                        this.xAxisData=res.data.Data.XAxisData;
                        this.series=res.data.Data.Series;
                        this.drawLineChart();
					 }).catch(error=>{
                     alert('网络错误');
                   })
			     	}							        	              
      },
        created(){	               	
		},
        mounted: function () {
            this.drawLineChart()
        },
        updated: function () {
            this.drawLineChart()
        }
}

</script>
<style scoped>
    .chart-container {
        width: 100%;
        float: left;
    }
    .chart div {
        height: 100%;
        float: left;
    }

    .el-col {
        padding: 30px 20px;
    }
</style>

            



// WEBPACK FOOTER //
// chartLine.vue?766cf07a